import React from "react";
import isNil from "lodash/isNil";
import { useDrawerStatus } from "~/native-ui";
import { navigationService } from "~/native-ui";
import { AppBarMenuContext } from "./AppBarMenuContext";

export const AppBarMenuContextProvider = (props) => {
    const value = props.value;
    const [openItems, setOpenItems] = React.useState([]);
    const indexCounter = React.useRef(0);
    const itemIndexRef = React.useRef(null);
    const isOpen = useDrawerStatus() === "open";

    const handleSetItems = React.useCallback((openItems) => {
        navigationService.setForceCloseDrawer(false);
        setOpenItems(openItems);
    }, [navigationService, setOpenItems]);


    const getItemIndex = React.useCallback((parentIdx, idx) => {
        if (itemIndexRef.current === null) {
            itemIndexRef.current = parentIdx;
        }

        if (itemIndexRef.current === parentIdx && idx === 0) {
            indexCounter.current = 0;
        }

        return indexCounter.current++
    }, []);


    const shouldOpen = React.useCallback(() => {
        return navigationService.drawerStatus !== "closed"
    }, [navigationService])

    
    React.useEffect(() => {
        if (isOpen) { return; }
        setOpenItems([])
    }, [isOpen]);

    
    const providerProps = {
        ...props,
        value: React.useMemo(() => (
            value ?? {
                setOpenItems: handleSetItems,
                shouldOpen,
                openItems,
                getItemIndex
            }
        ), [value, openItems, handleSetItems])
    }
    
    return <AppBarMenuContext.Provider { ...providerProps } />
}